export const animationSettings = {
  reel: {
    'default': ['static'],
    'WIN-ANIMATE:DONE': ['play', false, 'reel-decor-general'],
    'RESPIN-INTRO-ANIM': ['play', false, 'reel-react-on-delorean'],
  },
  logo: {
    'default': ['static'],
    'TEST': ['play', false],

    'STATE:IN:WIN': ['play', false],
  },

  Infinity: {
    'default': ['static'],
    'RESPIN-INTRO-ANIM': ['play', false],
    'tween': {
      type: 'move',
      startX: -420,
      endX: 1400,
      startY: 960,
      endY: 960,
      outX: 3200,
      outY: 960,
      durationIn: 2,
      durationOut: 2,
      delayIn: 0,
      delayOut: 0,
      easeIn: 'SlowMo.in',
      easeOut: 'SlowMo.out',
    },
  },

  tumbleweed: {
    'default': ['static'],
    'RESPIN-INTRO-ANIM': ['play', true],
    'tween': {
      type: 'move',
      startX: 960,
      endX: 0,
      startY: 960,
      endY: 960,
      outX: -400,
      outY: 960,
      durationIn: 2,
      durationOut: 1,
      delayIn: 0,
      delayOut: 0,
      easeIn: 'quad.in',
      easeOut: 'quad.out',
    },
  },

  delorianBack: {
    'default': ['static'],
    'STATE:IN:RESPIN': ['play', false],
    'tween': {
      type: 'move',
      startX: -420,
      endX: 1400,
      startY: 960,
      endY: 960,
      outX: 3200,
      outY: 960,
      durationIn: 2,
      durationOut: 2,
      delayIn: 4,
      delayOut: 0,
      easeIn: 'SlowMo.in',
      easeOut: 'SlowMo.out',
    },
  },

}
